import { render, staticRenderFns } from "./string.vue?vue&type=template&id=161f3632"
import script from "./string.vue?vue&type=script&lang=js"
export * from "./string.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports